import { render, staticRenderFns } from "./DocumentoValor.vue?vue&type=template&id=44ce3598"
import script from "./DocumentoValor.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentoValor.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports